module.exports = __webpack_public_path__ + "static/media/zameen-aurum-aerial-views.7ca83fb4.jpg";